import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

function XAuthComplete() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const dispatch = useDispatch();

	useEffect(() => {
		const token = searchParams.get('token');
		const returnUrl = searchParams.get('returnUrl');
		const error = searchParams.get('error');

		if (error) {
			navigate('/login', { replace: true });
			return;
		}

		if (token) {
			dispatch({ type: 'X_AUTH_COMPLETE', payload: { token, returnUrl } });
		} else {
			navigate(returnUrl || '/', { replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
			<p>Signing you in...</p>
		</div>
	);
}

export default XAuthComplete;
